module.exports = (__webpack_require__("dll-reference wxsys"))("./core/header.js");